import { useWebBillingHost } from './context';
import type { BillingPermissionCheck } from './types';

/** The host's permission check of the signed-in user. */
export function usePermissions(): BillingPermissionCheck {
  return useWebBillingHost().permissions.usePermissions();
}
